import { useState } from 'react';

// Parents often unmount a dialog as soon as it closes, which skips its exit
// animation. Close through requestClose and onClose fires once the slide-out ends.
export function useDialogExitTransition(onClose: () => void) {
  const [isClosing, setIsClosing] = useState(false);
  const [isEntered, setIsEntered] = useState(false);

  const transitionProps = {
    onEntered: () => setIsEntered(true),
    onExited: () => {
      setIsEntered(false);
      if (!isClosing) return;
      setIsClosing(false);
      onClose();
    },
  };

  return {
    isClosing,
    isEntered,
    requestClose: () => setIsClosing(true),
    transitionProps,
  };
}
